import axios from 'axios'
import { useCallback, useContext, useEffect, useMemo } from 'react'
import AdminUserContext from '../context/AdminUser'
import OscContext from '../context/Osc'
import api from '../helpers/api'

const useApi = () => {

  const CancelToken = useMemo( () => {
    return axios.CancelToken.source()
  }, [] )

  const { state: adminUser } = useContext( AdminUserContext )
  const { state: oscUser } = useContext( OscContext )
  

  const cancelableApi = useMemo( () => {
    api.interceptors.request.use( config => {
      return {
        ...config,
        cancelToken: CancelToken.token
      }
    })
    return api
  }, [ CancelToken ] )

  const cancel = useCallback( () => {
    CancelToken.cancel()
  }, [ CancelToken ] )

  useEffect( () => {
    let user = adminUser ? adminUser : oscUser
    cancelableApi.interceptors.request.use( config => {
      if( user && user.access_token  ) {
        config.headers = {
          ...config.headers,
          'Authorization': 'Bearer ' + user.access_token
        }
      }
      return config
    })
  }, [ oscUser , adminUser, cancelableApi ] )

  useEffect( () => {
    return () => {
      cancel()
    }
  }, [ cancel ] )

  return cancelableApi
}

export default useApi
